import { render, staticRenderFns } from "./SortConfig.vue?vue&type=template&id=456a57f3"
import script from "./SortConfig.vue?vue&type=script&lang=js"
export * from "./SortConfig.vue?vue&type=script&lang=js"
import style0 from "./SortConfig.vue?vue&type=style&index=0&id=456a57f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports